import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { rutaInicio } from "@/lib/constants";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-2">
        <Loader2 className="h-8 w-8 animate-spin text-ink-3" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (user.debe_cambiar_password && location.pathname !== "/cambiar-password") {
    return <Navigate to="/cambiar-password" replace />;
  }

  if (roles && !roles.includes(user.rol)) {
    return <Navigate to={rutaInicio(user)} replace />;
  }

  return children;
}
